import { render, staticRenderFns } from "./index.vue?vue&type=template&id=caa7244a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=caa7244a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa7244a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserTabs: require('/opt/build/repo/components/user-tabs/UserTabs.vue').default,AddBoardModal: require('/opt/build/repo/components/DashboardModals/addBoardModal.vue').default,Loading: require('/opt/build/repo/components/Loading.vue').default})
